import {
  appBaseErrorData,
  hasAppBaseErrorCode,
} from '../../streamlain/hooks/app-base-error-code';
import {
  OfflineMutationDomainError,
  OfflineMutationTransientError,
} from './offline-mutation-outbox';

export const PERMANENT_DELETE_DOMAIN_CODES = [
  'DATABASE_DELETE_BLOCKED',
  'DATABASE_DELETE_TOO_LARGE',
  'DATABASE_DELETE_TOO_MANY_APPS',
  'FORBIDDEN',
  'BAD_REQUEST',
  'NOT_FOUND',
  'CONFLICT',
] as const;

export function classifyOfflineMutationError(
  error: unknown,
  domainCodes: readonly string[]
): OfflineMutationDomainError | OfflineMutationTransientError {
  const message = error instanceof Error ? error.message : String(error);
  return domainCodes.some(code => hasAppBaseErrorCode(error, code))
    ? new OfflineMutationDomainError(message)
    : new OfflineMutationTransientError(message);
}

/**
 * The outbox error class of a failed server lifecycle call (trash, restore,
 * permanent delete), by code and failure class only. A refusal carries its
 * failure class (under `blockedCode`) or its refusal code as message, which
 * picks the text the user reads; every other error retries under the same
 * operation id.
 */
export function classifyLifecycleMutationError(
  error: unknown,
  blockedCode: string,
  refusalCodes: readonly string[]
): OfflineMutationDomainError | OfflineMutationTransientError {
  const failureClass = appBaseErrorData(error, blockedCode)?.failureClass;
  if (typeof failureClass === 'string') {
    return new OfflineMutationDomainError(failureClass);
  }
  const refusal = refusalCodes.find(code => hasAppBaseErrorCode(error, code));
  if (refusal) return new OfflineMutationDomainError(refusal);
  return new OfflineMutationTransientError(
    error instanceof Error ? error.message : String(error)
  );
}

export const OFFLINE_DELETE_COPY_CONFIRMATION =
  'OFFLINE_DELETE_COPY_CONFIRMATION';
/** The server refused a container delete without a choice for each of its tables. */
export const OFFLINE_DELETE_TABLE_CHOICE = 'APP_BASE_TABLE_CHOICE_MISSING';
